var _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCities(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg4548",
    xmlSpace: "preserve",
    width: 682.66669,
    height: 682.66669,
    viewBox: "0 0 682.66669 682.66669",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs4552"
  }, /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath4562"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,512 H 512 V 0 H 0 Z",
    id: "path4560"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "g4554",
    transform: "matrix(1.3333333,0,0,-1.3333333,0,682.66667)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g4556"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g4558",
    clipPath: "url(#clipPath4562)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g4564",
    transform: "translate(332,465.7129)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c 67.313,-30.195 114.369,-99.276 114.369,-179.67 0,-30.021 -6.562,-58.459 -18.287,-83.888 -9.503,-20.61 -27.689,-47.243 -51.082,-74.155",
    style: {
      fill: "none",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path4566"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4568",
    transform: "translate(355,104)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c -44.784,-47.565 -99,-96.5 -99,-96.5 0,0 -141.544,128.427 -172.082,194.655 -11.725,25.431 -18.287,53.868 -18.287,83.888 0,108.197 85.231,195.904 190.369,195.904 7.785,0 15.46,-0.48 23,-1.415",
    style: {
      fill: "none",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path4570"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4572",
    transform: "translate(195.9995,409.2178)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 C 16.643,8.474 35.225,13.533 54.878,14.285",
    style: {
      fill: "none",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path4574"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4576",
    transform: "translate(358.8765,374.8857)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c 20.237,-24.303 32.455,-55.867 32.455,-90.36 0,-76.813 -60.588,-139.078 -135.331,-139.078 -74.744,0 -135.332,62.265 -135.332,139.078 0,41.792 17.937,79.277 46.332,104.77",
    style: {
      fill: "none",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path4578"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4580",
    transform: "translate(291.2852,394)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 H 29.458",
    style: {
      fill: "none",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path4582"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4584",
    transform: "translate(291.2852,335.667)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 H 29.458",
    style: {
      fill: "none",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path4586"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4588",
    transform: "translate(291.2852,277.333)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 H 29.458",
    style: {
      fill: "none",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path4590"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4592",
    transform: "translate(291.2852,219)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 H 29.458",
    style: {
      fill: "none",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path4594"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4596",
    transform: "translate(155.4043,196.7148)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 V 103.827 H 99.719 V -51.268",
    style: {
      fill: "none",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path4598"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M 332.058,449.237 H 279.965 V 504.5 h 52.093 z",
    style: {
      fill: "none",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path4600"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g4602",
    transform: "translate(255.4272,145.4473)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 V 303.79 H 101.168 V 49.989",
    style: {
      fill: "none",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path4604"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4606",
    transform: "translate(189.3989,340.2773)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 V -38.449",
    style: {
      fill: "none",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path4608"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4610",
    transform: "translate(220.1411,372.3223)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 V -70.494",
    style: {
      fill: "none",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path4612"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4614",
    transform: "translate(188.27,262.3789)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 V -15.379",
    style: {
      fill: "none",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path4616"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4618",
    transform: "translate(188.27,208.248)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 V -15.38",
    style: {
      fill: "none",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path4620"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4622",
    transform: "translate(221.27,262.3789)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 V -15.379",
    style: {
      fill: "none",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path4624"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4626",
    transform: "translate(221.27,208.248)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 V -15.38",
    style: {
      fill: "none",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path4628"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCities);
export default __webpack_public_path__ + "static/media/cities.447ae71b8cbb3578a36671eb07ac9cd8.svg";
export { ForwardRef as ReactComponent };